export default {"src":"/_next/static/media/linkedin.280d4e5a.svg","height":30,"width":31,"blurWidth":0,"blurHeight":0};